export default __webpack_public_path__ + "static/media/remove.3d3ba81b.svg";